import React from 'react';
import TextField from 'material-ui/TextField';
import { BLUE } from '../constants/index'

class CustomTextField extends React.PureComponent {

  render() {
    let {
      input,
      autoFocus = false,
      underlineShow = true,
      underlineStyle = {},
      floatingLabelText = 'TextField',
      floatingLabelFocusStyle = {},
      floatingLabelStyle = {},
      maxLength = '',
      name = '',
      type = 'text',
      autoComplete = 'off',
      errorText = '',
      floatingLabelFixed = true
    } = this.props

    underlineStyle = Object.assign({
      borderColor: 'black',
    }, underlineStyle)

    floatingLabelFocusStyle = Object.assign({
      color: BLUE
    }, floatingLabelFocusStyle)

    floatingLabelStyle = Object.assign({
      color: BLUE
    }, floatingLabelStyle)

    const errorStyle = {
      textAlign: 'left',
      fontSize: '12px'
    }

    return (
      <div style={{
        maxHeight: '72px'
      }}>
        <TextField
          name={name}
          type={type}
          underlineShow={underlineShow}
          underlineStyle={underlineStyle}
          underlineFocusStyle={underlineStyle}
          floatingLabelText={floatingLabelText}
          floatingLabelFocusStyle={floatingLabelFocusStyle}
          floatingLabelStyle={floatingLabelStyle}
          floatingLabelFixed={floatingLabelFixed}
          maxLength={maxLength}
          autoComplete={autoComplete}
          errorText={errorText}
          errorStyle={errorStyle}
          autoFocus={autoFocus}
          {...input}
        />
      </div>
    )
  }
}

export default CustomTextField;


// WEBPACK FOOTER //
// ./src/components/CustomTextField.js